<template>
  <div class="content flex-box" v-if="activity">
    <data-list
      ref="dataList"
      class="flex-grow"
      url="/activity/activity-enroll"
      entity-name="报名"
      add-btn="添加人员"
      hide-show-detail
      :custom-url="customUrl"
      :before-edit="beforeEdit"
      :before-update="beforeUpdate"
      :query="query"
      :action="action"
      :columns="columns"
      :rules="rules"
      :modal-width="640"
      :modal-form="modalForm">
      <template v-slot:button v-if="editable">
        <a-button @click="importEnroll"><a-icon type="upload" />批量导入</a-button>
        <a-button type="primary" :loading="exporting" @click="exportEnroll">{{exporting ? '正在导出' : '批量导出'}}</a-button>
      </template>
      <template v-slot:query="{form}">
        <a-form-model-item label="">
          <a-input v-model="form.keyword" placeholder="输入嘉宾姓名或手机号查询" style="width: 200px"></a-input>
        </a-form-model-item>
      </template>
      <template v-slot:edit="{form}">
        <a-form-model-item label="姓名" prop="name">
          <a-input v-model="form.name" placeholder="请输入姓名"></a-input>
        </a-form-model-item>
        <a-form-model-item label="手机号码" prop="mobile">
          <a-input v-model="form.mobile" placeholder="请输入手机号码"></a-input>
        </a-form-model-item>
        <a-form-model-item label="性别" prop="gender">
          <a-select v-model="form.gender" :options="genderList" placeholder="请选择性别"></a-select>
        </a-form-model-item>
        <a-form-model-item label="证件类型" prop="type">
          <a-select v-model="form.type" :options="guestIdTypeList" placeholder="请选择证件类型"></a-select>
        </a-form-model-item>
        <a-form-model-item label="证件号码" prop="num">
          <a-input v-model="form.num" placeholder="请输入证件号码"></a-input>
        </a-form-model-item>
        <a-form-model-item label="企业名称" prop="work">
          <a-input v-model="form.work" placeholder="请输入企业名称"></a-input>
        </a-form-model-item>
        <a-form-model-item label="职位" prop="position">
          <a-input v-model="form.position" placeholder="请输入职位"></a-input>
        </a-form-model-item>
        <!-- <a-form-model-item label="身份" prop="id_type">
          <a-select v-model="form.id_type" :options="idTypeOptions" placeholder="请选择身份"></a-select>
        </a-form-model-item>
        <a-form-model-item label="参加会议" prop="meeting">
          <a-checkbox-group v-model="form.conference" :options="meetingOptions" placeholder="请选择参加会议"></a-checkbox-group>
        </a-form-model-item> -->
      </template>
    </data-list>
    <batch-import-modal
      v-model="visible"
      name="报名导入模板.xlsx"
      url="https://zk-static-1301841918.cos.ap-nanjing.myqcloud.com/wb/activity/assets/new-enroll_template.xlsx"
      import-url="/activity/activity-enroll/import"
      :activity="activity.id * 1"
      @import="handleImport"></batch-import-modal>
  </div>
</template>

<script>
    import {genderList, getGenderText, getIdTypeText, guestIdTypeList} from "../../common/activity/guest";
    import batchImportModal from "../../components/batch-import-modal";
    import mixins from "./mixins";

    export default {
        name: "ActivityEnroll",
        components: {
            batchImportModal
        },
        data() {
            return {
                columns: [
                    {title: '姓名', dataIndex: 'name'},
                    {title: '手机号码', dataIndex: 'mobile'},
                    {title: '性别', dataIndex: 'gender', customRender: text => getGenderText(text)},
                    {title: '证件类型', dataIndex: 'type', customRender: text => getIdTypeText(text)},
                    {title: '证件号码', dataIndex: 'num'},
                    {title: '企业名称', dataIndex: 'work'},
                    {title: '职位', dataIndex: 'position'},
                    // {title: '身份', dataIndex: 'id_type'},
                    // {title: '参选会议', dataIndex: 'meeting'},
                ],
                rules: {
                    name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
                    mobile: [
                        { required: true, message: '请输入手机号码', trigger: 'blur' },
                        { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
                    ],
                    gender: [{ required: true, message: '请选择性别', trigger: 'change' }],
                    type: [{ required: true, message: '请选择证件类型', trigger: 'change' }],
                    num: [{ required: true, message: '请输入证件号码', trigger: 'blur' }],
                    work: [{ required: true, message: '请输入企业名称', trigger: 'blur' }],
                    position: [{ required: true, message: '请输入职位', trigger: 'blur' }],
                    // id_type: [{ required: true, message: '请选择身份', trigger: 'change' }],
                    // conference: [{ required: true, message: '请选择参加会议', trigger: 'change' }],
                },
                guestIdTypeList,
                idTypeOptions: ["参会人员", "工作人员", "媒体人员", "安保人员"].map(item => Object({label: item, value: item})),
                meetingOptions: [
                    "人才大会开幕式",
                    "“创客天下·杭向未来”杭州海外高层次人才",
                    "创新创业大赛总决赛",
                    "中国留学生论坛",
                    "“我们在杭州”外国人才创新成果展",
                ].map(item => Object({label: item, value: item})),
                genderList,
                visible: false,
                exporting: false,
                modalForm: {
                    labelAlign: 'right',
                    labelCol: {span: 6},
                    wrapperCol: {span: 18}
                },
                moduleKey: 'enroll',
            }
        },
        mixins: [mixins],
        computed: {
            action() {
                return this.editable ? ['add', 'delete', 'update', 'query', 'audit'] : ['query'];
            },
            activity() {
                return this.$store.getters.activity;
            },
            query() {
                let res = '';
                const activity = this.activity;
                if(activity) {
                    res += `&filter[activity_id]=${activity.id}`
                }
                return res;
            }
        },
        methods: {
            exportEnroll() {
                if(this.exporting) return;
                this.exporting = true;
                let url = `/activity/activity-enroll/export?activity_id=${this.activity.id}`;
                this.$axios(url, {noTempleFilter: true, responseType: 'blob'}).then(res => {
                    this.exporting = false;
                    const content = res;
                    const blob = new Blob([content])
                    const fileName = "报名数据.xlsx";
                    if ('download' in document.createElement('a')) { // 非IE下载
                        const elink = document.createElement('a')
                        elink.download = fileName;
                        elink.style.display = 'none'
                        elink.href = URL.createObjectURL(blob)
                        document.body.appendChild(elink)
                        elink.click()
                        URL.revokeObjectURL(elink.href) // 释放URL 对象
                        document.body.removeChild(elink)
                    } else { // IE10+下载
                        navigator.msSaveBlob(blob, fileName)
                    }
                }).catch(() => {
                    this.exporting = false;
                });
            },
            customUrl(form) {
                let res = '';
                if(form.keyword) {
                    res = `&filter[or][0][name][like]=${form.keyword}&filter[or][1][tel][like]=${form.keyword}`;
                }
                return res;
            },
            beforeEdit(form, fn) {
                if(form.meeting) {
                    form.conference = form.meeting.split(",");
                }
                fn();
            },
            beforeUpdate(form, fn) {
                if(!form.id) {
                    form.activity_id = this.activity.id;
                    form.type = 1;
                }
                if (form.conference) {
                    form.meeting = form.conference.join(",");
                }
                fn();
            },
            importEnroll() {
                this.visible = true;
            },
            handleImport() {
                this.visible = false;
                this.$refs.dataList.getList();
            },
        }
    }
</script>

<style scoped lang="less">
</style>
